import type { InputHTMLAttributes, SelectHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

const field =
	"h-9 w-full rounded-md border border-line bg-surface px-3 text-sm text-ink placeholder:text-ink-faint focus:border-line-strong focus:outline-none";

export const Input = ({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) => (
	<input className={cn(field, className)} {...props} />
);

export const Select = ({ className, ...props }: SelectHTMLAttributes<HTMLSelectElement>) => (
	<select className={cn(field, "cursor-pointer pr-8", className)} {...props} />
);
